import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n";
import Landing from "@/pages/Landing";
import Plan from "@/pages/Plan";
import Results from "@/pages/Results";
import Decision from "@/pages/Decision";
import Evaluate from "@/pages/Evaluate";
import Loyalty from "@/pages/Loyalty";
import XPDecision from "@/pages/XPDecision";
import Watch from "@/pages/Watch";
import Journey from "@/pages/Journey";

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/plan" element={<Plan />} />
          <Route path="/results" element={<Results />} />
          <Route path="/trip/:id" element={<Decision />} />
        <Route path="/evaluate" element={<Evaluate />} />
          <Route path="/loyalty" element={<Loyalty />} />
          <Route path="/loyalty/decision" element={<XPDecision />} />
          <Route path="/watch" element={<Watch />} />
          <Route path="/journey" element={<Journey />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
